import { ArrowRight } from "lucide-react";
import { GarageFlowLogo } from "@/components/Brand";
import { StatusBadge } from "@/components/common";
import { t } from "@/i18n";

export default function SelectGarage({ staff, onSelect }) {
  return (
    <div className="min-h-screen bg-slate-50 px-5 py-12">
      <div className="mx-auto max-w-2xl">
        <GarageFlowLogo />
        <h1 className="mt-10 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-testid="select-garage-title">{t("pro.selectTitle")}</h1>
        <p className="mt-2 text-slate-600">{t("pro.selectSubtitle")}</p>
        <div className="mt-8 grid gap-4">
          {staff.map((m, i) => (
            <button
              key={m.garage_id}
              type="button"
              onClick={() => onSelect(m.garage_id)}
              data-testid={`select-garage-${m.slug}`}
              style={{ animationDelay: `${i * 60}ms` }}
              className="gf-card gf-rise flex items-center gap-4 p-5 text-left transition-transform duration-200 hover:-translate-y-0.5"
            >
              <span className="h-10 w-2 rounded-full" style={{ background: m.primary_color }} />
              <div className="flex-1">
                <p className="font-display text-lg font-bold text-slate-900">{m.garage_name}</p>
                <p className="text-sm text-slate-500">/g/{m.slug}</p>
              </div>
              <StatusBadge status={m.role} />
              <ArrowRight className="h-5 w-5 text-slate-400" />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
